import React from 'react';
import { withPrefix } from 'gatsby-link';

import $ from 'jquery';

import './_portfolios.scss';


class Portfolios extends React.Component {
  componentDidMount() {
    const isBrowser = typeof window !== 'undefined';
    const AOS = isBrowser ? require('aos') : undefined;
    this.aos = AOS;
    this.aos.init();
  }

  componentDidUpdate() {
    this.aos.refresh();
  }

  render() {
    return (
      <section className="portfolio-cards-container">
        <img alt="Portfolio trend graph" src={withPrefix('images/graphics/portfolio-trend.svg')} className="portfolio-trend-image" />
        <div className="row">

          <div className="col-12 col-sm-6 col-md-4">
            <div className="card card-portfolio defensive">
              <h5 className="card-title">Defensive</h5>
              <div className="card-body">
                <p className="card-text">Lower risk, Lower return</p>

                <section>
                  <h6 className="card-caption">Allocation:</h6>
                  <div className="progress">
                    <div className="progress-bar bg-shares--light w-35" role="progressbar" aria-valuenow="35" aria-valuemin="0" aria-valuemax="100" />
                    <div className="progress-bar bg-bonds w-65" role="progressbar" aria-valuenow="65" aria-valuemin="0" aria-valuemax="100" />
                  </div>
                </section>

                <div className="allocation-block d-flex justify-content-around">
                  <div className="shares-percentage">
                    <span>35%</span>
                    <span>Shares</span>
                  </div>
                  <span className="divider" />
                  <div className="bonds-percentage">
                    <span>65%</span>
                    <span>Bonds</span>
                  </div>
                </div>
                <div className="badge badge-light">Core</div>
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4">
            <div className="card card-portfolio balanced">
              <h5 className="card-title">Balanced</h5>
              <div className="card-body">
                <p className="card-text">Medium risk, Medium return</p>

                <section>
                  <h6 className="card-caption">Allocation:</h6>
                  <div className="progress">
                    <div className="progress-bar bg-shares w-60" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" />
                    <div className="progress-bar bg-bonds w-40" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" />
                  </div>
                </section>

                <div className="allocation-block d-flex justify-content-around">
                  <div className="shares-percentage">
                    <span>60%</span>
                    <span>Shares</span>
                  </div>
                  <span className="divider" />
                  <div className="bonds-percentage">
                    <span>40%</span>
                    <span>Bonds</span>
                  </div>
                </div>
                <div className="badge badge-light">Core</div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-4">
            <div className="card card-portfolio growth">
              <h5 className="card-title">Growth</h5>
              <div className="card-body">
                <p className="card-text">High risk, Higher return</p>

                <section>
                  <h6 className="card-caption">Allocation:</h6>
                  <div className="progress">
                    <div className="progress-bar bg-shares w-95" role="progressbar" aria-valuenow="35" aria-valuemin="0" aria-valuemax="95" />
                    <div className="progress-bar bg-bonds--light w-5" role="progressbar" aria-valuenow="5" aria-valuemin="0" aria-valuemax="100" />
                  </div>
                </section>

                <div className="allocation-block d-flex justify-content-around">
                  <div className="shares-percentage">
                    <span>95%</span>
                    <span>Shares</span>
                  </div>
                  <span className="divider" />
                  <div className="bonds-percentage">
                    <span>5%</span>
                    <span>Bonds</span>
                  </div>
                </div>
                <div className="badge badge-light">Core</div>
              </div>
            </div>
          </div>
        </div>

      </section>
    );
  }
}

export default Portfolios;



// WEBPACK FOOTER //
// ./src/components/Portfolios/index.js